import { createContext, useContext, useState } from "react";

const ClientContext = createContext();

export const ClientProvider = ({ children }) => {
  const [clientName, setClientName] = useState(null);

  return (
    <ClientContext.Provider value={{ clientName, setClientName }}>
      {children}
    </ClientContext.Provider>
  );
};

export const useClient = () => useContext(ClientContext);
